import Stack from "@mui/material/Stack";
import { alpha } from "@mui/material/styles";
import { OutOfDateSnackbar } from "components/common/OutOfDateSnackbar";
import { AppNavbar } from "./components/AppNavbar";
import { SideMenu } from "./components/SideMenu";
import { RequireNavigation } from "src/routes/authentication";

export const DashboardLayout = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Stack sx={{ height: "100vh", width: "100vw", overflow: "hidden" }}>
      <OutOfDateSnackbar />
      <AppNavbar />
      <Stack
        direction="row"
        justifyContent="flex-start"
        sx={{
          height: 0,
          flexGrow: 1,
        }}
      >
        <RequireNavigation>
          <SideMenu />
        </RequireNavigation>
        <Stack
          component="main"
          id="main-content"
          sx={(theme) => ({
            width: 0,
            flexGrow: 1,
            height: "100%",
            backgroundColor: theme.vars
              ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
              : alpha(theme.palette.background.default, 1),
            overflow: "auto",
          })}
        >
          {children}
        </Stack>
      </Stack>
    </Stack>
  );
};
